import store from '../store'
import {CommonApi} from '../request/common_api'

// 人员状态
function getPersonStatus () {
  if (store.state.applyBase.personStatus.length) {
    return
  }
  // let list = [{codeNo: '0', codeName: '正常'}, {codeNo: '1', codeName: '注销'}, {codeNo: '2', codeName: '冻结'}]
  // store.commit('applyBase/setPersonStatus', list)
  CommonApi.getTableList('PERACCSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setPersonStatus', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 人员卡状态
function getCardStatus () {
  if (store.state.applyBase.cardStatus.length) {
    return
  }
  // let list = [{codeNo: '0', codeName: '正常'}, {codeNo: '1', codeName: '挂失'}, {codeNo: '9', codeName: '停用'}]
  // store.commit('applyBase/setCardStatus', list)
  CommonApi.getTableList('CARDSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setCardStatus', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 制卡状态
function getMakeCardTaskStatus () {
  if (store.state.applyBase.makeCardTaskStatus.length) {
    return
  }
  // let list = [{codeNo: '0', codeName: '采集单位个人信息'}, {codeNo: '1', codeName: '生成制卡准备数据'}, {codeNo: '2', codeName: '发卡'}]
  // store.commit('applyBase/setMakeCardTaskStatus', list)
  CommonApi.getTableList('MKCARDTASKSTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setMakeCardTaskStatus', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

// 设备状态
function getDeviceStatus () {
  if (store.state.applyBase.deviceStatus.length) {
    return
  }
  // let list = [{codeNo: '0', codeName: '正常'}, {codeNo: '1', codeName: '维修中'}, {codeNo: '2', codeName: '已报废'}]
  // store.commit('applyBase/setDeviceStatus', list)
  CommonApi.getTableList('DEVICESTU').then(res => {
    if (res.retCode === '0000') {
      store.commit('applyBase/setDeviceStatus', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

let getStatus = {
  getPersonStatus,
  getCardStatus,
  getMakeCardTaskStatus,
  getDeviceStatus
}

export {getStatus}



// WEBPACK FOOTER //
// ./src/util/applyBase_handleStatus.js